import { EXTERNAL_PACKAGE_PATTERN } from '@cli-constants/patterns.js'
import { DEFAULT_ADMIN_NAMESPACE } from '@cli-constants/scaffolding.js'

export function isExternalModuleSpecifier(specifier: string): boolean {
  if (specifier.startsWith('.') || specifier.startsWith('/')) {
    return false
  }

  if (new RegExp(`^@${DEFAULT_ADMIN_NAMESPACE}(?:/|$)`).test(specifier)) {
    return false
  }

  return EXTERNAL_PACKAGE_PATTERN.test(specifier)
}
